module.exports = __webpack_public_path__ + "img/world-map.763fd4a67eeb8814883e45a05a6de294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/world-map.png
// module id = 327
// module chunks = 0